export const CHECKOUT_URL =
  'https://sistema-electricista-domiciliario-desde-cero.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#oferta'

export const PRICE = '$19.990'
export const BONUS_VALUE = '$39.950'

export const BRAND = 'CM DIGITAL PRO'
export const PRODUCT = 'SISTEMA ELECTRICISTA DOMICILIARIO DESDE CERO'
export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/cxTZsw3f7vZ5GbsFvDs7HG/Imagen_de_Codex_4_sept_2026,_16_45_32.png'

export const pains = [
  {
    icon: '😵‍💫',
    title: 'INFORMACIÓN DISPERSA',
    desc: 'Guardas videos y tutoriales, pero cada uno explica algo diferente y no sabes cómo conectar todo.',
  },
  {
    icon: '❓',
    title: 'NO SABES QUÉ APRENDER PRIMERO',
    desc: 'Fase, neutro, circuitos, herramientas, multímetro... hay tantos conceptos que empezar parece complicado.',
  },
  {
    icon: '⚡',
    title: 'TE FALTA UNA RUTA',
    desc: 'Tienes ganas de aprender una habilidad útil, pero necesitas un camino que vaya desde lo básico hacia lo práctico.',
  },
  {
    icon: '😩',
    title: 'SIGUES POSTERGANDO',
    desc: 'Quieres comenzar, pero pasan las semanas y continúas buscando información en lugar de avanzar.',
  },
]

export const tomos = [
  {
    label: 'TOMO 1',
    title: 'FUNDAMENTOS DE ELECTRICIDAD Y SEGURIDAD',
    desc: 'Comprende tensión, corriente, resistencia, potencia, Ley de Ohm y los principios esenciales de seguridad.',
  },
  {
    label: 'TOMO 2',
    title: 'HERRAMIENTAS, MATERIALES Y COMPONENTES',
    desc: 'Reconoce las principales herramientas, conductores, accesorios y componentes utilizados en electricidad domiciliaria.',
  },
  {
    label: 'TOMO 3',
    title: 'ANATOMÍA DE UNA INSTALACIÓN DOMICILIARIA',
    desc: 'Comprende tableros, protecciones, puesta a tierra, circuitos, símbolos y la estructura general de una instalación.',
  },
  {
    label: 'TOMO 4',
    title: 'ILUMINACIÓN, INTERRUPTORES Y TOMACORRIENTES',
    desc: 'Interpreta mediante diagramas la lógica de los circuitos domiciliarios más habituales.',
  },
  {
    label: 'TOMO 5',
    title: 'MEDICIONES Y MULTÍMETRO',
    desc: 'Comprende tensión, resistencia, continuidad, funciones del multímetro e interpretación de mediciones educativas.',
  },
  {
    label: 'TOMO 6',
    title: 'DIAGNÓSTICO DE FALLAS Y MÉTODO PROFESIONAL',
    desc: 'Aprende a razonar desde el síntoma hasta la hipótesis y la evidencia mediante casos de práctica.',
  },
]

export const bonuses = [
  {
    label: '🎁 BONO 1 — GRATIS',
    title: 'MANUAL DE DIAGNÓSTICO RÁPIDO DE FALLAS™',
    desc: 'Preguntas, fichas y árboles de decisión para desarrollar un razonamiento más ordenado frente a una falla.',
    value: '$7.990',
  },
  {
    label: '🎁 BONO 2 — GRATIS',
    title: 'KIT DE CHECKLISTS DEL ELECTRICISTA ORGANIZADO™',
    desc: 'Listas prácticas para organizar herramientas, materiales, mediciones, revisiones y procesos.',
    value: '$5.990',
  },
  {
    label: '🎁 BONO 3 — GRATIS',
    title: 'GUÍA VISUAL DE HERRAMIENTAS, MATERIALES Y COMPONENTES™',
    desc: 'Una referencia visual para reconocer rápidamente los elementos más importantes del oficio.',
    value: '$6.990',
  },
  {
    label: '🎁 BONO 4 — GRATIS',
    title: 'SIMULADOR DE DIAGNÓSTICO: 20 CASOS ELÉCTRICOS™',
    desc: 'Situaciones ficticias para practicar observación, hipótesis, evidencia y toma de decisiones.',
    value: '$8.990',
  },
  {
    label: '🎁 BONO 5 — GRATIS',
    title: 'PACK PROFESIONAL PARA INICIAR TU CAMINO COMO ELECTRICISTA™',
    desc: 'Plantillas para relevamientos, presupuestos, materiales, diagnósticos, seguimiento y organización.',
    value: '$9.990',
  },
]

export const benefits = [
  {
    icon: '⚡',
    title: 'MENOS CONFUSIÓN',
    desc: 'Deja de saltar entre contenidos y sigue una ruta desde los fundamentos hasta el diagnóstico inicial.',
  },
  {
    icon: '🔧',
    title: 'MÁS CONOCIMIENTO PRÁCTICO',
    desc: 'Comprende herramientas, componentes, instalaciones, circuitos y mediciones con explicaciones visuales.',
  },
  {
    icon: '🏠',
    title: 'COMPRENDE LO QUE ESTÁS VIENDO',
    desc: 'Empieza a mirar un esquema o una instalación y reconocer qué elementos forman parte del sistema y qué función cumplen.',
  },
  {
    icon: '🚀',
    title: 'UNA NUEVA HABILIDAD',
    desc: 'Construye conocimientos que pueden convertirse en el primer paso hacia nuevas oportunidades de aprendizaje y desarrollo.',
  },
]

export const testimonials = [
  {
    name: 'Diego Fernández',
    role: 'Ayudante de obra, 27 años',
    place: 'Rosario, Argentina',
    text: 'Yo tenía 40 videos guardados y seguía sin saber qué estudiar primero. Con los tomos ordenados entendí de una vez qué es tensión, qué es resistencia y por qué salta el térmico. En la obra ahora entiendo lo que me explica el oficial en lugar de asentir sin saber.',
  },
  {
    name: 'Marcelo Ibáñez',
    role: 'Operario de mantenimiento, 41 años',
    place: 'Córdoba, Argentina',
    text: 'Lo que más me sirvió fue el Tomo 5. Tenía un multímetro guardado en el cajón y no lo usaba por miedo a hacer algo mal. Ahora entiendo qué mido, para qué lo mido y cómo leer el resultado como evidencia y no como adivinanza.',
  },
  {
    name: 'Laura Quiroga',
    role: 'Encargada de edificio, 35 años',
    place: 'Montevideo, Uruguay',
    text: 'Necesitaba entender la instalación del edificio para saber cuándo llamar al electricista y cuándo no. El Tomo 3 me explicó el recorrido completo: alimentación, tablero, protecciones y circuitos. Hoy puedo describir un problema con criterio.',
  },
  {
    name: 'Cristian Molina',
    role: 'Emprendedor, 32 años',
    place: 'Santiago, Chile',
    text: 'Compré buscando un oficio con salida y encontré una ruta real. Los 20 casos del simulador me obligaron a pensar antes de tocar: síntoma, riesgo, hipótesis, evidencia. Ese método me cambió la cabeza más que cualquier tutorial suelto.',
  },
  {
    name: 'Héctor Ramírez',
    role: 'Electricista en formación, 48 años',
    place: 'Guadalajara, México',
    text: 'A mi edad pensé que ya era tarde para ordenar lo que sabía a medias. Los diagramas y los checklists me dieron estructura y las plantillas del Bono 5 me sirvieron para presupuestar mis primeros trabajos con seriedad.',
  },
]

export const offerHighlights = [
  '6 TOMOS + 5 BONOS',
  '🎁 Bonos valorados en $39.950',
]

export const faqs = [
  {
    q: '¿Es físico o digital?',
    a: 'Es un producto 100% digital.',
  },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. El sistema comienza desde los fundamentos.',
  },
  {
    q: '¿Qué voy a aprender?',
    a: 'Fundamentos, seguridad, herramientas, componentes, instalaciones, circuitos, multímetro, mediciones y diagnóstico inicial.',
  },
  {
    q: '¿Incluye ejercicios?',
    a: 'Sí. Incluye diagramas, actividades, checklists y casos de práctica.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los 5 bonos están incluidos gratis durante esta oferta.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. El precio de la oferta es $19.990, sin mensualidades.',
  },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. Recibes acceso digital después de completar tu compra.',
  },
  {
    q: '¿Esto me habilita profesionalmente?',
    a: 'No. Es un producto educativo y no sustituye certificaciones, matrículas, licencias, experiencia supervisada ni habilitaciones profesionales.',
  },
  {
    q: '¿Puedo aprender a mi ritmo?',
    a: 'Sí. Puedes avanzar y repasar el contenido según tu disponibilidad.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Escríbenos a soportescmdigital@gmail.com.',
  },
]

export const purchaseAlerts = [
  { name: 'Martín Gutiérrez', city: 'Córdoba', country: 'Argentina' },
  { name: 'Leandro Sosa', city: 'Rosario', country: 'Argentina' },
  { name: 'Javier Domínguez', city: 'La Plata', country: 'Argentina' },
  { name: 'Gustavo Peralta', city: 'Mendoza', country: 'Argentina' },
  { name: 'Nicolás Benítez', city: 'Mar del Plata', country: 'Argentina' },
  { name: 'Ariel Cabrera', city: 'San Miguel de Tucumán', country: 'Argentina' },
  { name: 'Facundo Ramírez', city: 'Salta', country: 'Argentina' },
  { name: 'Sergio Villalba', city: 'Neuquén', country: 'Argentina' },
  { name: 'Emiliano Acosta', city: 'Bahía Blanca', country: 'Argentina' },
  { name: 'Rodrigo Medina', city: 'Santa Fe', country: 'Argentina' },
  { name: 'Pablo Ferreyra', city: 'Buenos Aires', country: 'Argentina' },
  { name: 'Hernán Quiroga', city: 'San Juan', country: 'Argentina' },
]
